import { createSelector } from '@ngrx/store';
import * as fromStatements from '../reducers';
import * as fromStatementsReducer from '../reducers/statement.reducer';

export const selectAllStatements = createSelector(
  fromStatements.selectStatementEntitiesState,
  fromStatementsReducer.loadPaymentStatementsResponse
);

export const selectStatementsLoaded = createSelector(fromStatements.selectStatementEntitiesState, state => state.loaded);

export const selectStatementsFailure = createSelector(
  fromStatements.selectStatementEntitiesState,
  fromStatementsReducer.loadPaymentsStatementsFailure
);


//   selectStatementsMeta,
//   (state) => state.totalItems
//   selectStatementsMeta,
//   (state) => state.itemCount
//   selectStatementsMeta,
//   (state) => state.itemsPerPage
//   selectStatementsMeta,
//   (state) => state.currentPage
